<template>
  <div class="field-sections">
    <div class="field-sections__directions">
      Selecciona las zonas deseadas del campo
    </div>
    <div class="field-sections__conditions__field__sections">
      <div class="tab-zone__map">
        <div class="checkbox-controllers">
          <div>
            <div class="checkbox-item" :class="checkbox44 ? 'selected' : ''" @click="selectFieldSector1">
              <div>4/4</div>
              <div class="checkbox-item__checkbox">
                <img v-if="checkbox44" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_check.svg" />
              </div>
            </div>
          </div>
          <div>
            <div class="checkbox-item" :class="checkbox34 ? 'selected' : ''" @click="selectFieldSector2">
              <div>3/4</div>
              <div class="checkbox-item__checkbox">
                <img v-if="checkbox34" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_check.svg" />
              </div>
            </div>
          </div>
          <div>
            <div class="checkbox-item" :class="checkbox24 ? 'selected' : ''" @click="selectFieldSector3">
              <div>2/4</div>
              <div class="checkbox-item__checkbox">
                <img v-if="checkbox24" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_check.svg" />
              </div>
            </div>
          </div>
          <div>
            <div class="checkbox-item" :class="checkbox14 ? 'selected' : ''" @click="selectFieldSector4">
              <div>1/4</div>
              <div class="checkbox-item__checkbox">
                <img v-if="checkbox14" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_check.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="zona-map-controller">
          <div>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/blue_arrow.svg" alt="cancha" class="field-arrow" />
            <template v-for="(sector, index) in fieldSectors">
              <div
                :key="index"
                class="zona-map-controller__sector-map"
                :class="[sector.status ? 'selected' : '', system == 'unknown' ? 'sector-map-hover' : '']"
                @click="selectFieldSector(index, sector.num)"
              >
                <div />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMobileOperatingSystem } from '@/utils/misc';
import { mapGetters } from 'vuex';

export default {
  name: 'MediaPlayerFieldSections',
  props: {
    fieldSectors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      system: null,
      selectFieldGroupSector1: true,
      selectFieldGroupSector2: true,
      selectFieldGroupSector3: true,
      selectFieldGroupSector4: true,
      zone: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      group1: [16, 15, 14, 13],
      group2: [12, 11, 10, 9],
      group3: [8, 7, 6, 5],
      group4: [4, 3, 2, 1],
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['isUserSessionLive']),
    fieldSectorsByFieldQuarters() {
      return this.fieldSectors.reduce(
        (accumulator, fieldSector) => {
          const fieldQuarter = Math.ceil(fieldSector.num / 4);
          accumulator[`${fieldQuarter}/4`].push(fieldSector);
          return accumulator;
        },
        {
          '1/4': [],
          '2/4': [],
          '3/4': [],
          '4/4': [],
        },
      );
    },
    checkbox14() {
      return this.fieldSectorsByFieldQuarters['1/4'].every(fieldSector => fieldSector.status);
    },
    checkbox24() {
      return this.fieldSectorsByFieldQuarters['2/4'].every(fieldSector => fieldSector.status);
    },
    checkbox34() {
      return this.fieldSectorsByFieldQuarters['3/4'].every(fieldSector => fieldSector.status);
    },
    checkbox44() {
      return this.fieldSectorsByFieldQuarters['4/4'].every(fieldSector => fieldSector.status);
    },
  },
  methods: {
    updateCheckF() {
      return;
      // this.updateCheck += 1;
    },
    selectFieldSector(index, num) {
      if (this.isUserSessionLive) {
        if (!this.fieldSectors[index].status) {
          this.fieldSectors[index].status = true;
        } else {
          if (this.zone.length > 1) {
            this.fieldSectors[index].status = false;
          }
        }
        const value = this.zone.indexOf(num);
        value === -1 ? this.zone.push(num) : this.zone.length > 1 ? this.zone.splice(value, 1) : null;
        this.validateField(index);
      } else {
        // this.setPreviewSectionAnalytics('');
        // this.setSectionAnalytics('Popup_AF_Tops');
        // this.SET_PREMIUM_MESSAGE(true);
      }
    },
    selectFieldSector1() {
      if (this.isUserSessionLive) {
        if (!this.selectFieldGroupSector1) {
          this.group1.map(index => {
            const found = this.fieldSectors.findIndex(element => element.num == index);
            this.fieldSectors[found].status = true;
          });
          this.group1.forEach(zone => {
            let section = zone;
            let value = this.zone.indexOf(section);
            value === -1 ? this.zone.push(section) : null;
          });
        } else {
          if (this.selectFieldGroupSector2 || this.selectFieldGroupSector3 || this.selectFieldGroupSector4) {
            this.group1.map(index => {
              const found = this.fieldSectors.findIndex(element => element.num == index);
              this.fieldSectors[found].status = false;
            });
            this.group1.forEach(zone => {
              let section = zone;
              let value = this.zone.indexOf(section);
              value === -1 ? null : this.zone.splice(value, 1);
            });
          } else {
            if (this.zone.length > 4) {
              this.group1.map(index => {
                const found = this.fieldSectors.findIndex(element => element.num == index);
                this.fieldSectors[found].status = false;
              });
              this.group1.forEach(zone => {
                let section = zone;
                let value = this.zone.indexOf(section);
                value === -1 ? null : this.zone.splice(value, 1);
              });
            } else {
              this.selectFieldGroupSector1 = true;
              this.updateCheckF();
            }
          }
        }

        this.selectFieldGroupSector1 = !this.selectFieldGroupSector1;
      } else {
        // this.setPreviewSectionAnalytics('');
        // this.setSectionAnalytics('Popup_AF_Tops');
        // this.SET_PREMIUM_MESSAGE(true);
      }
    },
    selectFieldSector2() {
      if (this.isUserSessionLive) {
        if (!this.selectFieldGroupSector2) {
          this.group2.map(index => {
            const found = this.fieldSectors.findIndex(element => element.num == index);
            this.fieldSectors[found].status = true;
          });
          this.group2.forEach(zone => {
            let section = zone;
            let value = this.zone.indexOf(section);
            value === -1 ? this.zone.push(section) : null;
          });
        } else {
          if (this.selectFieldGroupSector1 || this.selectFieldGroupSector3 || this.selectFieldGroupSector4) {
            this.group2.map(index => {
              const found = this.fieldSectors.findIndex(element => element.num == index);
              this.fieldSectors[found].status = false;
            });
            this.group2.forEach(zone => {
              let section = zone;
              let value = this.zone.indexOf(section);
              value === -1 ? null : this.zone.splice(value, 1);
            });
          } else {
            if (this.zone.length > 4) {
              this.group2.map(index => {
                const found = this.fieldSectors.findIndex(element => element.num == index);
                this.fieldSectors[found].status = false;
              });
              this.group2.forEach(zone => {
                let section = zone;
                let value = this.zone.indexOf(section);
                value === -1 ? null : this.zone.splice(value, 1);
              });
            } else {
              this.selectFieldGroupSector2 = true;
              this.updateCheckF();
            }
          }
        }
        this.selectFieldGroupSector2 = !this.selectFieldGroupSector2;
      } else {
        // this.setPreviewSectionAnalytics('');
        // this.setSectionAnalytics('Popup_AF_Tops');
        // this.SET_PREMIUM_MESSAGE(true);
      }
    },
    selectFieldSector3() {
      if (this.isUserSessionLive) {
        if (!this.selectFieldGroupSector3) {
          this.group3.map(index => {
            const found = this.fieldSectors.findIndex(element => element.num == index);
            this.fieldSectors[found].status = true;
          });
          this.group3.forEach(zone => {
            let section = zone;
            let value = this.zone.indexOf(section);
            value === -1 ? this.zone.push(section) : null;
          });
        } else {
          if (this.selectFieldGroupSector2 || this.selectFieldGroupSector1 || this.selectFieldGroupSector4) {
            this.group3.map(index => {
              const found = this.fieldSectors.findIndex(element => element.num == index);
              this.fieldSectors[found].status = false;
            });
            this.group3.forEach(zone => {
              let section = zone;
              let value = this.zone.indexOf(section);
              value === -1 ? null : this.zone.splice(value, 1);
            });
          } else {
            if (this.zone.length > 4) {
              this.group3.map(index => {
                const found = this.fieldSectors.findIndex(element => element.num == index);
                this.fieldSectors[found].status = false;
              });
              this.group3.forEach(zone => {
                let section = zone;
                let value = this.zone.indexOf(section);
                value === -1 ? null : this.zone.splice(value, 1);
              });
            } else {
              this.selectFieldGroupSector3 = true;
              this.updateCheckF();
            }
          }
        }
        this.selectFieldGroupSector3 = !this.selectFieldGroupSector3;
      } else {
        // this.setPreviewSectionAnalytics('');
        // this.setSectionAnalytics('Popup_AF_Tops');
        // this.SET_PREMIUM_MESSAGE(true);
      }
    },
    selectFieldSector4() {
      if (this.isUserSessionLive) {
        if (!this.selectFieldGroupSector4) {
          this.group4.map(index => {
            const found = this.fieldSectors.findIndex(element => element.num == index);
            this.fieldSectors[found].status = true;
          });
          this.group4.forEach(zone => {
            let section = zone;
            let value = this.zone.indexOf(section);
            value === -1 ? this.zone.push(section) : null;
          });
        } else {
          if (this.selectFieldGroupSector2 || this.selectFieldGroupSector1 || this.selectFieldGroupSector3) {
            this.group4.map(index => {
              const found = this.fieldSectors.findIndex(element => element.num == index);
              this.fieldSectors[found].status = false;
            });
            this.group4.forEach(zone => {
              let section = zone;
              let value = this.zone.indexOf(section);
              value === -1 ? null : this.zone.splice(value, 1);
            });
          } else {
            if (this.zone.length > 4) {
              this.group4.map(index => {
                const found = this.fieldSectors.findIndex(element => element.num == index);
                this.fieldSectors[found].status = false;
              });
              this.group4.forEach(zone => {
                let section = zone;
                let value = this.zone.indexOf(section);
                value === -1 ? null : this.zone.splice(value, 1);
              });
            } else {
              this.selectFieldGroupSector4 = true;
              this.updateCheckF();
            }
          }
        }
        this.selectFieldGroupSector4 = !this.selectFieldGroupSector4;
      } else {
        // this.setPreviewSectionAnalytics('');
        // this.setSectionAnalytics('Popup_AF_Tops');
        // this.SET_PREMIUM_MESSAGE(true);
      }
    },
    validateField(index) {
      if (index === 0 || index === 1 || index === 2 || index === 3) {
        this.selectFieldGroupSector1 = !!(
          this.fieldSectors[0].status &&
          this.fieldSectors[1].status &&
          this.fieldSectors[2].status &&
          this.fieldSectors[3].status
        );
      }
      if (index === 4 || index === 5 || index === 6 || index === 7) {
        this.selectFieldGroupSector2 = !!(
          this.fieldSectors[4].status &&
          this.fieldSectors[5].status &&
          this.fieldSectors[6].status &&
          this.fieldSectors[7].status
        );
      }
      if (index === 8 || index === 9 || index === 10 || index === 11) {
        this.selectFieldGroupSector3 = !!(
          this.fieldSectors[8].status &&
          this.fieldSectors[9].status &&
          this.fieldSectors[10].status &&
          this.fieldSectors[11].status
        );
      }
      if (index === 12 || index === 13 || index === 14 || index === 15) {
        this.selectFieldGroupSector4 = !!(
          this.fieldSectors[12].status &&
          this.fieldSectors[13].status &&
          this.fieldSectors[14].status &&
          this.fieldSectors[15].status
        );
      }
    },
  },
  created() {
    this.system = getMobileOperatingSystem();
  },
};
</script>

<style scoped lang="scss">
$blue: #132839;
@mixin fieldSize1 {
  height: 19.7125em;
  width: 11.875em;
}

.field-sections {
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__directions {
    margin-top: 1em;
    font-size: 0.687em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.22px;
    text-align: right;
    color: #5d6872;
  }

  &__conditions {
    display: grid;
    grid-template-columns: 1fr min-content 1fr;

    @media screen and (max-width: 1470px) {
      font-size: 0.8em;
    }

    @media screen and (max-width: 1345px) {
      font-size: 1em;
    }

    @media screen and (max-width: 534px) {
      font-size: 0.8em;
    }

    &__locality-time {
      width: 100%;
      height: min-content;
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 3.5em;
    }

    &__field {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media screen and (max-width: 1622px) {
        padding-left: 2%;
        align-items: flex-start;
      }

      @media screen and (max-width: 1345px) {
        padding-left: 0;
        align-items: center;
      }

      @media screen and (max-width: 600px) {
        padding-left: 2%;
        align-items: flex-start;
      }

      @media screen and (max-width: 330px) {
        align-items: flex-start !important;
        & div.advanced-filter__conditions__field__sections {
          margin-left: 8%;
        }
      }

      &__sections {
        margin-top: 0.6em;
        display: flex;
        justify-content: center;
      }
    }
  }
}
.zona-map-controller {
  @include fieldSize1;
  background-image: url('https://golstatsimages.blob.core.windows.net/todoelfut/cancha.png');
  background-repeat: no-repeat;
  background-size: 100% 102%;
  background-position-y: -0.1875em;
  //height: calc(100% - 3.5px);
  border: solid 2px #cbee6b;

  & > div {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    position: relative;

    & > img.field-arrow {
      position: absolute;
      height: 99%;
      left: 46%;
      z-index: 1;
    }
  }
  // margin-left: -10px;
  &__sector-map {
    border: solid 1.5px #cbee6b;
    text-align: center;
    line-height: 3.9375em;
    float: left;
    font-family: 'Avenir-Demi';
    font-size: 0.6875em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #084f60;
    cursor: pointer;

    & > div {
      height: 100%;
      width: 100%;
    }
  }

  &__sector-map.selected {
    & > div {
      background-color: #cbee6b;
      opacity: 0.2;
    }
  }
}
.checkbox-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Roboto-Bold, sans-serif;
  font-weight: bold;
  font-size: 10.8px;
  padding: 0.4em 0.3em 0.4em;
  cursor: pointer;
  border-radius: 2.7px;
  border: solid 0.9px #132839;

  &__checkbox {
    border-radius: 1.8px;
    background-color: #132839;
    width: 14.4px;
    height: 14.4px;

    & > img {
      margin-top: 3px;
    }
  }

  &.selected {
    border-radius: 3px;
    color: $blue;
    border: solid 1px #cbee6b;
    background-color: #cbee6b !important;

    & .checkbox-item__checkbox {
      background-color: #8b0;
    }
  }
}
.tab-zone {
  &__map {
    @include fieldSize1;
    position: relative;

    .checkbox-controllers {
      position: absolute;
      top: 0;
      right: -3rem;
      display: flex;
      flex-flow: column;
      justify-content: space-around;
      height: 100%;
    }
  }
}
.checkbox-item:hover {
  color: #132839;
  @media screen and (max-width: 500px) {
    border: solid 1px #3c6eb5;
    background: none;
    color: #3c6eb5;
  }
}
.checkbox-item.selected {
  color: #132839 !important;
  border: solid 1px #cbee6b;
  background-color: #cbee6b !important;
}
</style>

<style lang="scss">
.field-sections__conditions__field__sections {
  & .checkbox-item {
    & label.b-checkbox.checkbox {
      margin-right: 0;
      margin-left: 0.5em;
    }
  }
}
</style>
